export default __webpack_public_path__ + "static/ASW-GB-Geschaeftsfuehrung-7b8cbf551281c52a0f99a3b8f071e0a3.mp4";